import React, { useState } from 'react';
import { FiInfo, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import {
  InfoContainer,
  InfoHeader,
  InfoTitle,
  ToggleButton,
  InfoContent,
  InfoTable,
  TableRow,
  TableHeader,
  TableCell,
  IconCell
} from './InfoPanel.styles';

const InfoPanel = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <InfoContainer>
      <InfoHeader onClick={() => setIsExpanded(!isExpanded)}>
        <InfoTitle>
          <FiInfo size={18} />
          Diferença entre Pausar e Desabilitar
        </InfoTitle>
        <ToggleButton>
          {isExpanded ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
        </ToggleButton>
      </InfoHeader>

      {isExpanded && (
        <InfoContent>
          <InfoTable>
            <thead>
              <TableRow $isHeader>
                <TableHeader>Ação</TableHeader>
                <TableHeader>Temporário</TableHeader>
                <TableHeader>Persiste após Reiniciar</TableHeader>
                <TableHeader>Remove do Agendador</TableHeader>
              </TableRow>
            </thead>
            <tbody>
              <TableRow>
                <TableCell><strong>Pausar</strong></TableCell>
                <IconCell $success>✓</IconCell>
                <IconCell $error>✗</IconCell>
                <IconCell $error>✗</IconCell>
              </TableRow>
              <TableRow>
                <TableCell><strong>Desabilitar</strong></TableCell>
                <IconCell $error>✗</IconCell>
                <IconCell $success>✓</IconCell>
                <IconCell $success>✓</IconCell>
              </TableRow>
            </tbody>
          </InfoTable>

          <p style={{ marginTop: '15px', fontSize: '14px', color: '#6c757d' }}>
            <strong>Pausar:</strong> Suspende temporariamente as execuções. O job volta a funcionar após reiniciar o servidor.
            <br />
            <strong>Desabilitar:</strong> Remove permanentemente o job do agendador. Necessário habilitá-lo manualmente para voltar a funcionar.
          </p>
        </InfoContent>
      )}
    </InfoContainer>
  );
};

export default InfoPanel;
